interface TargetScrollTopOptions {
  extraOffset?: number
  margin?: number
}

export function getTargetScrollTop(targetElement: Element, container: HTMLElement, options: TargetScrollTopOptions = {}): number {
  const { extraOffset = 0, margin = 10 } = options
  const rect = targetElement.getBoundingClientRect()
  const containerRect = container.getBoundingClientRect()
  const topObstructionHeight = getTopObstructionHeight(container, containerRect)
  const elementRelativeTop = rect.top - containerRect.top + container.scrollTop
  const targetScrollTop = elementRelativeTop - topObstructionHeight - margin - extraOffset
  const maxScroll = container.scrollHeight - container.clientHeight
  return Math.min(maxScroll, Math.max(0, targetScrollTop))
}

export function scrollInstantWithCorrection(targetElement: HTMLElement, container: HTMLElement, options: TargetScrollTopOptions & { onSettled?: () => void } = {}): void {
  const { onSettled, ...measureOptions } = options
  container.scrollTo({ top: getTargetScrollTop(targetElement, container, measureOptions), behavior: 'instant' })
  requestAnimationFrame(() => {
    const correctedTop = getTargetScrollTop(targetElement, container, measureOptions)
    if (Math.abs(correctedTop - container.scrollTop) > 1) {
      container.scrollTo({ top: correctedTop, behavior: 'instant' })
    }
    onSettled?.()
  })
}